"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var HotelPath = function HotelPath() {
  return /*#__PURE__*/_react["default"].createElement("path", {
    id: "hotel",
    d: "M1 5.763v-.676c0-.38.216-.727.556-.896L7.112 1.44c.56-.277 1.216-.277 1.776 0l5.556 2.751c.34.169.556.516.556.896v.676c0 .241-.196.437-.438.437-.241 0-.437.196-.437.438V13c0 .552-.448 1-1 1H10.75c-.552 0-1-.448-1-1v-.6c0-.552-.448-1-1-1h-1.5c-.552 0-1 .448-1 1v.6c0 .552-.448 1-1 1H2.875c-.552 0-1-.448-1-1V6.638c0-.242-.196-.438-.438-.438C1.196 6.2 1 6.004 1 5.762z"
  });
};
var _default = exports["default"] = HotelPath;